import { PureComponent, ReactNode } from 'react';

import * as styles from './search-file.style';

export type FileProps = {
  title?: ReactNode;
  footer?: any;
  children?: ReactNode;
};

export default class SearchFile extends PureComponent<FileProps> {
  render() {
    const { title, footer } = this.props;

    return (
      <styles.FileWrapper>
        <styles.File>
          <styles.FileHeader>{title}</styles.FileHeader>

          <styles.FileContentWrapper>
            <styles.FileContent>{this.props.children}</styles.FileContent>
          </styles.FileContentWrapper>

          {footer && <styles.FileFooter>{footer}</styles.FileFooter>}
        </styles.File>
      </styles.FileWrapper>
    );
  }
}
